export function loadImageAsync(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = (error) => reject(error);
    image.src = src;
  });
}

export function getScale(image, dest = 1280) {
  if (image.width > dest || image.height > dest) {
    return image.width > image.height
      ? dest / image.width
      : dest / image.height;
  } else {
    return 1;
  }
}

export function resizeCanvas(sourceCanvas, maxWidth = 1980, maxHeight = 1980) {
  // スケールを計算
  const scale = Math.min(
    maxWidth / sourceCanvas.width,
    maxHeight / sourceCanvas.height
  );

  // 新しいサイズを計算
  const destWidth = Math.floor(sourceCanvas.width * scale);
  const destHeight = Math.floor(sourceCanvas.height * scale);

  // 新しいキャンバスを作成
  const destCanvas = document.createElement('canvas');
  destCanvas.width = destWidth;
  destCanvas.height = destHeight;

  // 画質向上のためのオプション
  const ctx = destCanvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';

  // 元のキャンバスの内容を新しいキャンバスに描画
  ctx.drawImage(
    sourceCanvas,
    0,
    0,
    sourceCanvas.width,
    sourceCanvas.height,
    0,
    0,
    destWidth,
    destHeight
  );

  return destCanvas;
}

export function resizeImage(file, maxWidth = 1980, maxHeight = 1980) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxWidth) {
          height = Math.round((height *= maxWidth / width));
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = Math.round((width *= maxHeight / height));
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          resolve(new File([blob], file.name, { type: 'image/jpeg' }));
        },
        'image/jpeg',
        0.85
      );
    };

    img.onerror = reject;
  });
}

export function drawResizedImageToCanvas(canvas, image) {
  const scale = getScale(image);
  const destWidth = image.width * scale;
  const destHeight = image.height * scale;
  canvas.width = destWidth;
  canvas.height = destHeight;
  canvas
    .getContext('2d')
    .drawImage(
      image,
      0,
      0,
      image.width,
      image.height,
      0,
      0,
      destWidth,
      destHeight
    );
  return canvas;
}
